import { createContext, useContext } from 'react';

type LayoutContextValue = {
  closeSidebar: () => void;
  isDesktopSidebarOpen: boolean;
  isSidebarOpen: boolean;
  sidebarWidth: number;
  toggleSidebar: () => void;
};

const LayoutContext = createContext<LayoutContextValue | null>(null);

export const LayoutContextProvider = LayoutContext.Provider;

export const useLayoutContext = (): LayoutContextValue | null => {
  return useContext(LayoutContext);
};
